import React, { useEffect, useState } from 'react'
import GetExpense from '../../../APIs/Master/Expense/GetExpense';
import GetProject from '../../../APIs/Project/GetProject';
import GetVendorDetails from '../../../APIs/AddVendor/GetVendorDetails';
import UpdateWorkOrder from '../../../APIs/WorkOrder/UpdateWorkOrder';
import InsertWorkOrder from '../../../APIs/WorkOrder/InsertWorkOrder';
import SideMessage from '../../../components/SideMessage';
import Loader from '../../../components/Loader';
import { useParams } from 'react-router-dom';
import GetWorkOrder from '../../../APIs/WorkOrder/GetWorkOrder';

export default function AddWorkOrder(props) {
    let [expenseList, setExpenseList] = useState([]);
    let [projectList, setProjectList] = useState([])
    let [vendorList, setVendorList] = useState([])
    let [sendForm, setSendForm] = useState({
        expenseTypeId: 0,
        projectId: 0,
        vendorId: 0,
        amount: 0,
        timePeriod: 0,
        timePeriodUnit: 1,
        userId: window.userId,
    })
    const { id } = useParams();
    const [isShowLoader, setIsShowLoader] = useState(0)
    const [sideToster, setSideToster] = useState({
        show: 0,
        message: '',
        type: ''
    })

    const getWorkOrder = async (id) => {
        try {
            setIsShowLoader(1);
            let workorder = await GetWorkOrder(id)
            if (workorder.status === 1) {
                setSendForm(workorder?.responseValue[0])
                setIsShowLoader(0);
            }
            else {
                setSideToster({
                    message: workorder.responseValue,
                    show: 1,
                    type: 'alert'
                })
                setIsShowLoader(0);
            }
        }
        catch (error) {
            setSideToster({
                message: error.message,
                show: 1,
                type: 'alert'
            })
            setIsShowLoader(0);
        }

    }
    let getAllExpenses = async () => {
        const response = await GetExpense();
        if (response.status === 1) {
            setExpenseList(response.responseValue);
        }
    };
    let getProject = async () => {
        const project = await GetProject()
        if (project.status === 1) {
            setProjectList(project.responseValue)
        }
    };
    let getVendor = async () => {
        let vendor = await GetVendorDetails()
        if (vendor.status === 1) {
            setVendorList(vendor.responseValue)
        }
    };

    let handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value
        setSendForm({ ...sendForm, [name]: value })
    }

    const validateSendForm = (form) => {
        let errors = "";

        if (!form.expenseTypeId || form.expenseTypeId === 0) {
            errors = "Expense Type is required";
            return errors;
        }

        if (!form.projectId || form.projectId === 0) {
            errors = "Project is required";
            return errors;
        }

        if (!form.vendorId || form.vendorId === 0) {
            errors = "Vendor is required";
            return errors;
        }

        if (!form.amount || form.amount <= 0) {
            errors = "Amount must be greater than 0";
            return errors;
        }

        if (!form.timePeriod || form.timePeriod <= 0) {
            errors = "Time period must be greater than 0";
            return errors;
        }

        if (!form.timePeriodUnit) {
            errors = "Time period unit is required";
            return errors;
        }

        if (!form.userId) {
            errors = "User ID is required";
            return errors;
        }

        return errors;
    };

    const handleSaveForm = async () => {
        try {
            const error = validateSendForm(sendForm);
            if (error.length > 0) {
                setSideToster({
                    message: error,
                    show: 1,
                    type: 'Alert'
                });
                return;
            }
            setIsShowLoader(1);
            const response = await InsertWorkOrder(sendForm);
            if (response.status === 1) {
                setIsShowLoader(0);
                setSideToster({
                    message: 'Data Save',
                    show: 1,
                    type: 'Success'
                })
                setTimeout(() => {
                    props.closeModal(0);
                }, 600)
            }
            else {
                setIsShowLoader(0);
                setSideToster({
                    message: response?.responseValue,
                    show: 1,
                    type: 'Alert'
                })
            }
        }
        catch (e) {
            setIsShowLoader(0);
            setSideToster({
                message: e.message,
                show: 1,
                type: 'Alert'
            })
        }
    }
    const handleUpdate = async () => {
        try {
            const error = validateSendForm(sendForm);
            if (error.length > 0) {
                setSideToster({
                    message: error,
                    show: 1,
                    type: 'Alert'
                });
                return;
            }
            setIsShowLoader(1);
            const response = await UpdateWorkOrder(sendForm);
            if (response.status === 1) {
                setIsShowLoader(0);
                setSideToster({
                    message: 'Data Update',
                    show: 1,
                    type: 'Success'
                })
                props.setEditData({});
                props.setIsEdit(0);
                setTimeout(() => {
                    props.closeModal(0);
                }, 600)
            }
            else {
                setIsShowLoader(0);
                setSideToster({
                    message: response?.responseValue,
                    show: 1,
                    type: 'Alert'
                })
            }
        }
        catch (e) {
            setIsShowLoader(0);
            setSideToster({
                message: e.message,
                show: 1,
                type: 'Alert'
            })
        }
    }

    useEffect(() => {
        if (id) {
            getWorkOrder(id)
            
        }
    }, [id])

    useEffect(() => {
        getAllExpenses();
        getProject();
        getVendor();
    }, [])

    return (
        <div className='container-fluid landformconatiner p-4' >
            <h1 className="modal-title fs-5 text-primary" id="addexpensesLabel">Add Work Order</h1>
            <div className='wrapform'>
                <div className='row pb-4'>
                    <div className='col pb-2 pb-md-0'>
                        <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Expenses Type</label>
                            <select className='form-input-box form-select pe-5' name='expenseTypeId' value={sendForm?.expenseTypeId} onChange={handleChange} >
                                <option value="-1">--Select Expenses Type--</option>
                                {
                                    expenseList && expenseList.map((val, ind) => {
                                        return (
                                            <option value={val.id}>
                                                {val.name}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row pb-4'>
                    <div className='col pb-2 pb-md-0'>
                        <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Project Name</label>
                            <select className='form-input-box form-select pe-5' name='projectId' value={sendForm?.projectId} onChange={handleChange} >
                                <option value="-1">--Select Project--</option>
                                {
                                    projectList && projectList.map((val, ind) => {
                                        return (
                                            <option value={val.id}>
                                                {val.name}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row pb-4'>
                    <div className='col pb-2 pb-md-0'>
                        <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Vendor</label>
                            <select className='form-input-box form-select pe-5' name='vendorId' value={sendForm?.vendorId} onChange={handleChange} >
                                <option value="-1">--Select Vendor --</option>
                                {/* <option value="0">No Vendor</option> */}
                                {
                                    vendorList && vendorList.map((val, ind) => {
                                        return (
                                            <option value={val.id}>
                                                {val.name}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row pb-4'>
                    <div className='col pb-2 pb-md-0'>
                        <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Amount</label>
                            <input type='number' name="amount" className='form-input-box' id="amount" onChange={handleChange} value={sendForm?.amount} />
                        </div>
                    </div>
                </div>
                <div className='row pb-4'>
                    <div className='col-4 pb-2 pb-md-0'>
                        <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Time</label>
                            <input type='number' name="timePeriod" className='form-input-box' id="timePeriod" onChange={handleChange} value={sendForm?.timePeriod} />
                        </div>
                    </div>
                    <div className='col pb-2 pb-md-0'>
                        <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Period</label>
                            <select className='form-input-box form-select pe-5' name='timePeriodUnit' value={sendForm?.timePeriodUnit} onChange={handleChange} >
                                <option value="1">Days</option>
                                <option value="2">Weeks</option>
                                <option value="3">Months</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div className='d-flex flex-row justify-content-md-end'>
                {
                    !props.isEdit ?

                        <button className="btn export-save-btn" onClick={handleSaveForm}>Add Work Order</button>
                        :
                        <button className="btn export-save-btn" onClick={handleUpdate}>Update Work Order</button>

                }
            </div>
            {
                sideToster.show === 1 ?
                    <SideMessage close={setSideToster} show={sideToster.show} type={sideToster.type} message={sideToster.message} />
                    : ""
            }
            {
                <Loader show={isShowLoader} />
            }
        </div>
    )
}
